import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Spinner from '../common/spinner';
import { useTranslation } from 'react-i18next';

const OrderSendStatusDialog = ({ open, orderSendDone, orderSendFailed, okBtn }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                {!orderSendDone && <Spinner padding="20px" title={t('general.sending')} />}
                {orderSendDone && (
                    <div>
                        {orderSendFailed && <div>{t('order.orderSendFailedRetry')}</div>}
                        {!orderSendFailed && <div>{t('order.orderSendSuccess')}</div>}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" id="order-send-modal-ok" onClick={okBtn}>
                    {t('buttons.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default OrderSendStatusDialog;
